<lcp-header></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <!-- <div class="main-content"> -->
      <section class="lcp-section">
        <div class="lcp-section-content">
          <div class="display-flex">
            <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
              {{ fields['title'] }}
            </h1>
          </div>
        </div>
      </section>

      <section *ngFor="let section of fields['sections']"
        [ngClass]="['lcp-section', 'lcp-' + section.fields['slug']]"
        [class.is-inverted]="section.fields['inverted']">

        <div class="lcp-section-content">
          <h2 *ngIf="section.fields['title']" class="section-title">
            {{ section.fields['title'] }}
          </h2>
        
          <div class="section-main-content">
            <ng-container *ngIf="section.fields['slug'] == 'about-services'">
              <ng-content *ngTemplateOutlet="aboutServicesTemplate; context:{ section: section }"></ng-content>
            </ng-container>
    
            <ng-container *ngIf="section.fields['slug'] == 'about-process'">
              <ng-content *ngTemplateOutlet="aboutProcessSection; context:{ section: section }"></ng-content>
            </ng-container>
    
            <ng-container *ngIf="section.fields['slug'] == 'about-stories'">
              <!-- <ng-content *ngTemplateOutlet="aboutStoriesSection; context:{ section: section }"></ng-content> -->
            </ng-container>
    
            <!-- <ng-container *ngIf="['about-services','about-process','about-stories'].indexOf(section.fields['slug']) < 0">
              <code>FORMATTING NEEDED: {{ section.fields['slug'] }}</code>
            </ng-container> -->
          </div>
        </div>
      </section>  
    <!-- </div> -->
  </ng-container>
</div> 

<!-- <lcp-footer *ngIf="fields"></lcp-footer> -->




<ng-template #aboutServicesTemplate let-section="section">
  <div class="about-services-container">
    <div class="about-services-image-container">
      <!-- <img *ngIf="aboutServicesImageSrc" class="about-services-image" [src]="aboutServicesImageSrc"> -->
      <ng-container *ngFor="let block of section.fields['items']">
        
        <ng-container *ngFor="let svc of aboutServices"> 
          <ng-content *ngTemplateOutlet="aboutServiceImage; context:{ block: block, service: svc }"></ng-content>
        </ng-container>
      </ng-container>
    </div>

    <div class="about-services-text-container flex-50-not-sm">
      <div class="block-container" *ngFor="let block of section.fields['items']">

        <lcp-rich-text *ngIf="block.fields['slug'] == 'about-services-nav'" 
          class="lcp-subheading about-services-nav"
          [class.is-inverted]="section.fields['inverted']"
          [document]="block.fields['body']">
        </lcp-rich-text>

        <!-- <ng-container *ngFor="let svc of ['print', 'digital', 'environment', 'branding', 'audience_messaging']">
          <ng-content *ngTemplateOutlet="aboutService; context:{ block: block, service: svc }"></ng-content>
        </ng-container> -->

        <div
          class="about-services-details-container"
          #serviceDetails
          [@activeServiceChange]="{
            value: activeService(),
            params: {
              startHeight: serviceDetails.clientHeight || 0
            }
          }">
          <ng-content *ngTemplateOutlet="aboutService; context:{ block: block, service: activeService() }"></ng-content>
        </div>

      </div>
    </div>
  </div>
</ng-template>



<ng-template #aboutProcessSection let-section="section">
  <div class="block-container" *ngFor="let block of section.fields['items']">
    <div class="display-flex">
      <div class="flex-50-not-sm padding-bottom-50">
        <!-- {{ block.slug }} -->
        <lcp-rich-text
          class="lcp-subheading"
          [document]="block.fields['body']">
        </lcp-rich-text>
      </div>
    </div>

    <div class="about-process-details-container">
      <ng-container *ngFor="let container of block.fields['items']">
        <div class="about-process-details-container-inner">
          <ng-container *ngFor="let item of container.fields['items']">
            <div class="about-process-details-item flex-50-not-sm">
              <div class="about-process-detail-title">
                <div class="lcp-subheading">
                  {{ item.fields['title'] }}
                </div>
              </div>
              
              <div class="about-process-detail-body">
                <lcp-rich-text
                  [document]="item.fields['body']">
                </lcp-rich-text>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

</ng-template>

<ng-template #aboutServiceImage let-block="block" let-service="service">
  <ng-container *ngIf="block.fields['slug'] == service.fields?.slug && block.fields['media']" >
    <!-- IMG! {{ block.fields['media'][0].fields['title'] }} -->
    <div class="about-services-image-container-inner"
      [class.is-active]="isActiveAboutService(service) || (!fragment && defaultService == service.fields?.slug)">
      <img class="about-services-image"
        [src]="lcpHelper.srcFromMedia(block.fields['media'][0])"
        [attr.data-service]="service">
      <div class="about-services-image-spacer"></div>
    </div>
  </ng-container>
</ng-template>

<ng-template #aboutService let-block="block" let-service="service">
  <div *ngIf="block.fields['slug'] == 'about-services--' + service" 
    class="about-services-item"
    [innerHtml]="lcpHelper.htmlFromRichText(block.fields['body'])">
    <!-- [class.is-active]="fragment == service || (!fragment && defaultService == service)" -->
  </div>
</ng-template>

<ng-template #aboutStoriesSection let-section="section">
  <div class="about-story-section">
    <div class="about-story-container" *ngFor="let story of section.fields['items']">
      <div class="lcp-subheading story"
        [class.is-inverted]="section.fields['inverted']">
        <p>
          {{ story.fields['title'] }}
        </p>
      </div>
    </div>
  </div>
</ng-template>